// extracted by mini-css-extract-plugin
export var activeFilterButton = "_oi-c";
export var backButton = "_oi-4";
export var backIcon = "_oi-5";
export var chevronShortcut = "_oi-6";
export var container = "_oi-1";
export var editor = "_oi-8";
export var editorWrapper = "_oi-7";
export var prefix = "_oi-2";
export var searchIcon = "_oi-3";
export var suffix = "_oi-9";
export var suffixContent = "_oi-a";
export var suffixText = "_oi-b";
export var wrapper = "_oi-0";